module.exports = __webpack_public_path__ + "static/media/716d8cf1.jpeg";